module.exports = __webpack_public_path__ + "img/img36.ee941716.svg";